module.exports = require('./dist/commonjs/index.js').default;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/i18next-browser-languagedetector/index.js
// module id = 2735
// module chunks = 168707334958949